import { Editor, Node, Path, Range } from 'slate'

import { BLOCK_FORMATS, TCustomElement } from '../../interface/custom-types'

export const deleteForwardHelper = (editor: Editor) => {
  if (!editor.selection) {
    return
  }

  const path = Path.parent(Path.parent(editor.selection.anchor.path))

  // Here we find out the depths of the node to understand where to look for the next one
  const isEditorNode = Node.has(editor, path) && Editor.isEditor(Node.get(editor, path))

  const nextNodePath = isEditorNode
    ? Path.next(Path.parent(editor.selection.anchor.path))
    : Path.next(path)

  // When deleting using deleteForward, when we are at the end of a node, we prohibit
  // doing this if the next node is not a paragraph
  if (nextNodePath) {
    const isNodesExist =
      Node.has(editor, editor.selection.anchor.path) && Node.has(editor, nextNodePath)
    if (isNodesExist) {
      const currentNode = Node.get(editor, editor.selection.anchor.path)
      const nextNode = Node.get(editor, nextNodePath)
      if ((nextNode as TCustomElement).type !== BLOCK_FORMATS.paragraph) {
        const currentNodeStringLength = Node.string(currentNode).length
        const currentNodeRange = Range.end(editor.selection).offset

        if (currentNodeStringLength === currentNodeRange) {
          return true
        }
      }
    }
  }

  return false
}
